import router from "../../router";
import TopMessageHandler from '../topMessageHandler'

export const XHR_STATUS_DEFAULT = 'OK';
export const XHR_STATUS_WARNING = 'WARNING';
export const XHR_STATUS_ERROR   = 'ERROR';
export const XHR_STATUS_INVALID = 'INVALID';

/**
 * get a login referrer route from given route
 *
 * @param route
 * @returns {{name: string, replace: boolean}|{name: string, replace: boolean, params: {referrer: string}}}
 */
export function getLoginReferrer(route)
{
    if('string' === typeof route)
    {
        return {
            name: 'login-referrer',
            replace: true,
            params: {
                referrer: btoa(route)
            },
        };
    }

    if (route.name === 'logout' || route.meta.layout === 'minimal')
    {
        return {
            name: 'login',
            replace: true,
        };
    }

    return {
        name: 'login-referrer',
        replace: true,
        params: {
            referrer: btoa(route.path)
        },
    };
}

export function redirect(url, replace = true)
{
    const method = replace ? 'replace' : 'push';

    if ('string' === typeof url)
    {
        let match = router.matcher.match(url);

        if (router.currentRoute.fullPath !== match.fullPath)
        {
            router[method]({
                path: url,
            }).catch(console.error);
        }
    }
    else
    {
        router[method](url).catch(console.error);
    }
}

export function errorHandler(err)
{
    let message;
    if (typeof err === 'object' && err)
    {
        if (err.response && err.response.data.message)
        {
            message = err.response.data.message;
        }
        else if (err.data && typeof err.data === 'object' && err.data.message)
        {
            message = err.data.message;
        }
    }
    let isResponseMessage = !!message;
    message               = message || 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.';

    if (err instanceof Error || isResponseMessage)
    {
        return TopMessageHandler.error(message);
    }

    if (typeof err === 'string')
    {
        message = err;
    }
    else if (Array.isArray(err) && typeof err[0] === 'string')
    {
        message = err.message.join('<br>');
    }
    else if (typeof err === 'object' && err)
    {
        if (err.message)
        {
            message = err.message;
            if (Array.isArray(err.message))
            {
                message = err.message.join('<br>');
            }
        }
    }

    if (message !== null)
    {
        if (!message || typeof message !== 'string')
        {
            console.debug('[errorHandler] wrong data type for "err":', err);
            message = 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.';
        }

        TopMessageHandler.error(message);
    }
    else
    {
        console.debug('[errorHandler] wrong data type for "err":', err);
    }
}
